const saveChangesResponse = ({
  pageState: { editorBlocks },
  data: { success, updatedAt }
}) => {
  if (!success) return { editorHeaderStatus: 'error', editorIsSaving: false };

  return {
    editorBlocks: Object.keys(editorBlocks).reduce((blocks, blockId) => {
      blocks[blockId] = {
        ...editorBlocks[blockId],
        isEdited: false,
        isNew: false
      };

      return blocks;
    }, {}),
    editorChapterTitleIsEdited: false,
    editorHeaderStatus: 'saved',
    editorHeaderUpdatedAt: updatedAt,
    editorIsDraft: false,
    editorIsSaving: false
  };
};

export default saveChangesResponse;
